/*
 * @Author: kongxiangyu
 * @Date: 2022-11-28 13:49:19
 * @LastEditTime: 2022-11-29 12:41:52
 * @email: kongxiangyu@cd.baidu.com
 * @Description: Do not edit
 */
/**
* 发起轮询请求
* @param {*} params
*/
export default class PollingRequest {
    constructor(request, interval) {
        this.request = request;
        this.interval = interval;
    }
    startPolling() {
        this.request && this.request();
        this.timer = setTimeout(this.startPolling.bind(this), this.interval);
    };
    stopPolling() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
};